import { render } from "./ElementItem.vue?vue&type=template&id=148f928f&scoped=true"
import script from "./ElementItem.vue?vue&type=script&lang=js"
export * from "./ElementItem.vue?vue&type=script&lang=js"

import "./ElementItem.vue?vue&type=style&index=0&id=148f928f&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-148f928f"]])

export default __exports__